<template>
  <b-modal
    id="modal-order-update"
    ref="modal"
    v-model="open"
    size="lg"
    no-close-on-backdrop
    hide-footer
    title="UPDATE ORDER"
  >
    <b-overlay
      :show="modalLoading"
      blur="10px"
      opacity="0.30"
      rounded="sm"
      variant="light"
    >
      <ValidationObserver
        ref="createMerchantForm"
        v-slot="{ handleSubmit }"
        slim
      >
        <b-form
          class="my-8"
          @submit.prevent="handleSubmit(onClickUpdateOrder)"
        >
          <b-row>
            <b-col cols="4" />
          </b-row>
          <b-row>
            <b-col cols="6">
              <b-form-group
                label="Customer Name"
                label-for="h-name"
              >
                <b-form-input
                  id="name"
                  :value="getCustomerFieldValue('customer_name')"
                  type="text"
                  readonly
                  class="bg-light"
                />
              </b-form-group>
            </b-col>
            <b-col cols="6">
              <b-form-group
                label="Customer Address"
                label-for="h-addressLine1"
              >
                <b-form-input
                  id="addressLine1"
                  :value="getCustomerFieldValue('customer_address')"
                  type="text"
                  readonly
                  class="bg-light"
                />
              </b-form-group>
            </b-col>
            <b-col cols="6">
              <b-form-group
                label="Customer Mobile"
                label-for="Mobile"
              >
                <ValidationProvider
                  #default="{ errors }"
                  name="Mobile"
                  rules="required"
                >
                  <b-form-input
                    id="Mobile"
                    :value="getCustomerFieldValue('customer_phone')"
                    type="text"
                    :readonly="shouldMaskCustomerData"
                    :class="shouldMaskCustomerData ? 'bg-light' : ''"
                    @input="!shouldMaskCustomerData && (form.customer_phone = $event.target.value)"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </ValidationProvider>
              </b-form-group>
            </b-col>
            <b-col
              v-if="orderSettings.second_phone_number"
              cols="6"
            >
              <b-form-group
                label="Second Phone No"
                label-for="customerPhone"
              >
                <b-form-input
                  id="customerPhone"
                  :value="getCustomerFieldValue('customer_secondary_phone')"
                  type="text"
                  :readonly="shouldMaskCustomerData"
                  :class="shouldMaskCustomerData ? 'bg-light' : ''"
                  @input="!shouldMaskCustomerData && (form.customer_secondary_phone = $event.target.value)"
                />
              </b-form-group>
            </b-col>
            <b-col cols="6">
              <b-form-group
                label="Customer Email"
                label-for="h-email"
              >
                <b-form-input
                  id="email"
                  :value="getCustomerFieldValue('customer_email')"
                  type="email"
                  readonly
                  class="bg-light"
                />
              </b-form-group>
            </b-col>
            <b-col cols="6">
              <b-form-group
                label="Destination City"
                label-for="h-city"
              >
                <b-form-input
                  id="city"
                  :value="getCityName(form.destination_city_id)"
                  type="text"
                  readonly
                  class="bg-light"
                />
              </b-form-group>
            </b-col>
            <b-col cols="6">
              <b-form-group
                class="required"
                label="Weight"
                label-for="h-weight"
              >
                <ValidationProvider
                  #default="{ errors }"
                  name="COD"
                  rules="required"
                >
                  <b-form-input
                    id="weight"
                    ref="weightInput"
                    v-model="form.weight"
                    type="number"
                    placeholder="1"
                    autocomplete="nope"
                    step=".01"
                    pattern="^\d*(\.\d{0,2})?$"
                    @input="checkWeightRange"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </ValidationProvider>
              </b-form-group>
            </b-col>
          </b-row>

          <!-- submit and reset -->
          <b-row class="mt-3">
            <b-col
              offset-md="4"
            >
              <div>
                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  type="submit"
                  class="mr-1 custom-button-color"
                >
                  Submit
                </b-button>
                <b-button
                  v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                  type="reset"
                  variant="outline-secondary"
                >
                  Clear
                </b-button>
              </div>
            </b-col>
          </b-row>

          <!-- Weight History Section - TEMPORARILY COMMENTED OUT FOR RELEASE -->
          <!-- <weight-history
            :history="weightHistory"
          /> -->

          <b-row />
        </b-form>
      </ValidationObserver>
    </b-overlay>
  </b-modal>
</template>

<script>
import {
  BButton,
  BModal,
  BCol,
  BFormGroup,
  BForm,
  BFormInput,
  BRow,
  BOverlay,
  VBModal,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import SuccessMessage from '@core/mixins/SuccessMessage'
import ErrorMessage from '@core/mixins/ErrorMessage'
import { RepositoryFactory } from '@/repository/RepositoryFactory'
// import WeightHistory from './WeightHistory.vue' // TEMPORARILY COMMENTED OUT FOR RELEASE

const orderRepository = RepositoryFactory.get('order')
const ResourceRepository = RepositoryFactory.get('resource')
const OrderSettingsRepository = RepositoryFactory.get('orderSetting')

function initialState() {
  return {
    open: false,
    id: null,
    form: {
      order_no: '',
      customer_name: '',
      customer_address: '',
      customer_phone: '',
      customer_secondary_phone: '',
      customer_email: '',
      destination_city_id: '',
      cod: '',
      weight: '',
      description: '',
      remark: '',
      waybill_number: '',
    },
    modalLoading: false,
    loading: false,
    orderSettings: {},
    cityOptions: [],
    weightHistory: [],
    is_encrypted: false,
    originalOrderData: null,
  }
}

export default {
  directives: {
    'b-modal': VBModal,
    Ripple,
  },
  components: {
    BButton,
    BModal,
    BCol,
    BFormGroup,
    BForm,
    BFormInput,
    BRow,
    BOverlay,
    // WeightHistory, // TEMPORARILY COMMENTED OUT FOR RELEASE
  },
  mixins: [SuccessMessage, ErrorMessage],
  data() {
    return initialState()
  },
  computed: {
    canShowDecryptedOrders() {
      return this.$can('show-decrypted-orders')
    },
    shouldMaskCustomerData() {
      return this.is_encrypted && !this.canShowDecryptedOrders
    },
  },
  methods: {
    async openModal(id) {
      Object.assign(this.$data, initialState())
      this.open = true
      this.modalLoading = true
      this.id = id
      await this.fetchOrderDetails()
      await this.readOrderSetting()
      await this.fetchCityList()
      // await this.fetchWeightHistory() // TEMPORARILY COMMENTED OUT FOR RELEASE
      this.modalLoading = false
    },
    async fetchOrderDetails() {
      try {
        const { data } = (await orderRepository.getOrderDetailsById(this.id)).data
        this.is_encrypted = data.is_encrypted || false
        // Store original data for updates
        this.originalOrderData = data
        // Set form data - API returns decrypted data if user has permission
        this.form = data
      } catch (e) {
        this.convertAndNotifyError(e)
      }
    },
    checkWeightRange() {
      const minWeight = this.orderSettings.weight_range_setting.min_weight
      const maxWeight = this.orderSettings.weight_range_setting.max_weight
      const currentWeight = parseFloat(this.form.weight)
      if (this.orderSettings.weight_range_setting.enabled === true && (currentWeight < minWeight || currentWeight > maxWeight)) {
        this.validationState = false
        this.validationMessage = `The order weight should be between ${minWeight} Kg to ${maxWeight} Kg`
        this.isMaxWeight = true
      } else {
        this.validationState = true
        this.validationMessage = ''
        this.isMaxWeight = false
      }
      this.$refs.weightInput.setCustomValidity(this.validationMessage)
    },
    async readOrderSetting() {
      this.loading = true
      try {
        this.orderSettings = localStorage.getItem('order_setting') ? JSON.parse(localStorage.getItem('order_setting')) : (await OrderSettingsRepository.getOrderSettingsResource()).data.data
        if (!localStorage.getItem('order_setting')) localStorage.setItem('order_setting', JSON.stringify(this.orderSettings))
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.loading = false
    },

    async fetchCityList() {
      try {
        this.cityOptions = localStorage.getItem('city_list') ? JSON.parse(localStorage.getItem('city_list')) : (await ResourceRepository.getCityDropdownListMultilingual('')).data.data
        if (!localStorage.getItem('city_list')) localStorage.setItem('city_list', JSON.stringify(this.cityOptions))
      } catch (e) {
        this.convertAndNotifyError(e)
      }
    },

    getCustomerFieldValue(fieldName) {
      // If order is encrypted
      if (this.is_encrypted) {
        // If user has permission to view decrypted data, show real values
        if (this.canShowDecryptedOrders) {
          // API returns decrypted data when user has permission, so show real value
          return this.form[fieldName] || ''
        }
        // User doesn't have permission - show masked
        return '******'
      }

      // Order is not encrypted - show normal data
      return this.form[fieldName] || ''
    },
    getCityName(cityId) {
      if (!cityId || !this.cityOptions.length) return ''
      const city = this.cityOptions.find(c => c.id === cityId)
      return city ? city.name : ''
    },

    async fetchWeightHistory() {
      try {
        const response = await orderRepository.getOrderHistory(this.id)
        // The API returns data in response.data.data.history format
        this.weightHistory = response.data.data.history || []
      } catch (e) {
        this.weightHistory = []
      }
    },

    async onClickUpdateOrder() {
      this.modalLoading = true
      try {
        // If data is masked (encrypted and no permission), use original data for customer fields
        // Otherwise, use the form data (which may have been edited)
        const customerData = this.shouldMaskCustomerData && this.originalOrderData ? {
          customer_name: this.originalOrderData.customer_name,
          customer_address: this.originalOrderData.customer_address,
          customer_phone: this.originalOrderData.customer_phone,
          customer_secondary_phone: this.originalOrderData.customer_secondary_phone,
          customer_email: this.originalOrderData.customer_email,
        } : {
          customer_name: this.form.customer_name,
          customer_address: this.form.customer_address,
          customer_phone: this.form.customer_phone,
          customer_secondary_phone: this.form.customer_secondary_phone,
          customer_email: this.form.customer_email,
        }

        const payload = {
          general_data: {
            sender_type: 'merchant',
            merchant_id: this.form.merchant?.id || '',
            merchant_business_id: this.form.merchant_business?.id || '',
            origin_city_id: this.form.origin_city_id || '',
          },
          order_data: [
            {
              order_no: this.form.order_no,
              ...customerData,
              state_id: '',
              destination_city_id: this.form.destination_city_id,
              cod: this.form.cod,
              description: this.form.description,
              weight: this.form.weight,
              remark: '',
            },
          ],
        }
        await orderRepository.updateOrderDetails(this.id, payload)
        this.showSuccessMessage('Order Updated successfully')
        // Refresh weight history after update
        // await this.fetchWeightHistory() // TEMPORARILY COMMENTED OUT FOR RELEASE
        this.$parent.onClickRefresh()
        this.open = false
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.modalLoading = false
    },
  },
}
</script>
<style scoped>
@import "../../../node_modules/@syncfusion/ej2-base/styles/fabric.css";
@import "../../../node_modules/@syncfusion/ej2-vue-navigations/styles/fabric.css";
@import "../../../node_modules/@syncfusion/ej2-inputs/styles/fabric.css";
@import "../../../node_modules/@syncfusion/ej2-buttons/styles/fabric.css";
</style>
<style lang="scss" scoped>
@import '@core/scss/vue/required.scss';
.custom-button-color {
  background-color: #4186f5 !important;
  border-color: #4186f5 !important;
}
</style>
